import CryptoJS from "crypto-js";

export function decryptPermissions(base64Token, secretKey) {
  const raw = CryptoJS.enc.Base64.parse(base64Token);

  const bytes = raw.words;
  const sigBytes = raw.sigBytes;

  const u8 = new Uint8Array(sigBytes);

  for (let i = 0; i < sigBytes; i++) {
    u8[i] = (bytes[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
  }

  const iv = CryptoJS.lib.WordArray.create(u8.slice(0, 16));
  const ciphertext = CryptoJS.lib.WordArray.create(u8.slice(16));

  const key = CryptoJS.enc.Utf8.parse(secretKey);

  const decrypted = CryptoJS.AES.decrypt({ ciphertext }, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const json = decrypted.toString(CryptoJS.enc.Utf8);

  return JSON.parse(json);
}
